import type { ReactNode } from 'react'

export const NEWS_FONT_SIZE = 0.875

export interface NewsContentProps {
  children: ReactNode
}
